import React from 'react';
import { useTranslation } from 'react-i18next';
const FolderValidationWarning = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: "mt-5"
  }, t('a_name_must_be_present')), /*#__PURE__*/React.createElement("p", null, t('either_financial_or_technical_type_should_be_selected')));
};
export default FolderValidationWarning;